import { css } from 'lit';

export const EtitleDownloadStyles = css`
  .etitle-download {
    display: flex;
    place-content: center;
    margin-bottom: var(--fs-size-spacing-medium-2, 24px);
  }
`;
